import styled from "styled-components"
import { Label_s } from "styles/app-styles"

export const PortfolioDetail_s = styled.div`
  ${Label_s}{ margin: 20px 0 10px 0; }
  .p-data-table thead.p-datatable-thead > tr > th { padding: 0; }
  thead.p-datatable-thead > tr > th:first-child.p-selection-column { padding-left: 0 !important; }
  thead.p-datatable-thead > tr > th { padding: 0 5px 0 0 !important; }
  th.p-filter-column > div.p-checkbox { margin-left: 0 !important; }
`